import { render, staticRenderFns } from "./OrderPaymentSelect.vue?vue&type=template&id=0a8a2ca2&"
import script from "./OrderPaymentSelect.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports